// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Nohemi-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Nohemi-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
	scroll-behavior: smooth;
}

body {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
	'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
	sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
  background: #0a0409;
}

* {
  z-index: 1;
  margin: 0;
  box-sizing: border-box;
  padding: 0;
}

section {
  overflow: clip;
  width: 100%;
  scroll-margin-top: 100px;
}

@font-face {
  font-family: "NohemiRegular";
  src: local("NohemiRegular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
}

@font-face {
  font-family: "NohemiLight";
  src: local("NohemiLight"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;AACxB;;AAEA;CACC,SAAS;CACT;;WAEU;CACV,mCAAmC;CACnC,kCAAkC;EACjC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B;8DACsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B;8DACoD;EACpD,mBAAmB;AACrB","sourcesContent":["html {\n\tscroll-behavior: smooth;\n}\n\nbody {\n\tmargin: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n  background: #0a0409;\n}\n\n* {\n  z-index: 1;\n  margin: 0;\n  box-sizing: border-box;\n  padding: 0;\n}\n\nsection {\n  overflow: clip;\n  width: 100%;\n  scroll-margin-top: 100px;\n}\n\n@font-face {\n  font-family: \"NohemiRegular\";\n  src: local(\"NohemiRegular\"),\n    url(\"./fonts/Nohemi-Regular.otf\") format(\"opentype\");\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"NohemiLight\";\n  src: local(\"NohemiLight\"),\n    url(\"./fonts/Nohemi-Light.otf\") format(\"opentype\");\n  font-weight: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
